export const GreenCheckmark = ({ width = "24", height = "24" }: { width?: string; height?: string }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6L9 17L4 12"
      stroke="#22C55E"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
